import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import { Row } from 'reactstrap';

import { getWishlistOnSale } from 'Redux/ducks/wishlist';
import ProductCarousel from 'Components/HomePage/ProductCarousel';
import HitCard from 'Components/Cards/HitCard';
import MegaHitCard from 'Components/Cards/MegaHitCard';

const messages = defineMessages({
  items_on_your_wishlist: {
    id: 'wishlistsalecontainer.itemsonyourwishlist',
    defaultMessage: 'Items on Your Wishlist',
  },
});

const WishlistSaleContainer = ({ shouldFetchHits, containerClass }) => {
  const dispatch = useDispatch();
  // const onSaleWishlist = useSelector(state => state.wishlist.onSaleWishlist);
  const onSaleWishlist = useSelector(state => state.wishlist.items);

  useEffect(() => {
    if (shouldFetchHits) {
      dispatch(getWishlistOnSale());
    }
  }, [shouldFetchHits, dispatch]);

  const { formatMessage } = useIntl();
  if (!Array.isArray(onSaleWishlist) || onSaleWishlist.length === 0) return false;
  const slicedWishlist = onSaleWishlist.slice(0, 15);

  if (slicedWishlist.length === 1) {
    return (
      <div>
        {onSaleWishlist.map(hit =>
          <MegaHitCard
            hit={hit}
            key={hit.objectID}
          />,
        )}
      </div>
    );
  }

  if (slicedWishlist.length === 2) {
    return (
      <Row>
        {onSaleWishlist.map(hit =>
          <HitCard
            xsSize={6}
            smSize={6}
            mdSize={6}
            lgSize={6}
            sizesOverride="(min-width: 1520px) 645px, (min-width: 1200px) 550px, (min-width: 992px) 460px, (min-width: 768px) 340px, (min-width: 576px) 255px, 50vw"
            key={hit.product_id + Math.random()}
            hit={hit}
            lazyLoad={false}
          />,
        )}
      </Row>
    );
  }

  return (
    <div className={`wishlist-slider-container ${containerClass}`}>
      <ProductCarousel
        hitData={slicedWishlist}
        title={formatMessage(messages.items_on_your_wishlist)}
        viewAllBackgroundColor="light-black"
        viewAllLocation={'wishlist'}
      />
    </div>
  );
};

WishlistSaleContainer.propTypes = {
  shouldFetchHits: PropTypes.bool,
  containerClass: PropTypes.string,
};

WishlistSaleContainer.defaultProps = {
  shouldFetchHits: true,
  containerClass: '',
};

export default WishlistSaleContainer;
